import React, { memo, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Tour } from '@web/web5';
import moment from 'moment';
import { ACTIVITIES } from 'constants/Entities';
import { getLiteral } from 'utils/getLiteral';
import { setNewToursObj } from 'utils/tours';

const mapStateToProps = (state) => {
    const tabsNames = state.activities?.tabsNames || [];
    return { tours: state.config.components?.tours || {}, tabsNames };
};

const TimelineTour = memo(({ tours, tabsNames, id }) => {
    const hasTimelineTab = useMemo(() => {
        if (!tabsNames) return false;
        const conversationsTab = tabsNames.filter((tab) => tab === 'timeline');
        return !!conversationsTab.length;
    }, [tabsNames]);

    const stepsTourTimeline = useMemo(() => {
        return [
            {
                selector: '#activities-detail-timeline-tab-title',
                title: getLiteral('label_promotion_activities_conversations'),
                description: getLiteral('label_promotion_activities_conversations_body'),
                event: 'tour:end',
            },
        ];
    }, []);

    const onCloseTourTimeline = useCallback(() => {
        if (!id) return;

        const tour = tours?.[ACTIVITIES.entity]?.timeline || {};
        const count = tour?.count || 0;
        const disabled = count >= 2;
        setNewToursObj({ entity: ACTIVITIES, tourName: id, disabled });
    }, [tours, id]);

    const showTour = useMemo(() => {
        const tour = tours?.[ACTIVITIES.entity]?.timeline || {};
        const { disabled = false, count = 0, lastShown = undefined } = tour;
        const available = lastShown ? moment().diff(lastShown, 'hours') > 24 : true;
        return !disabled && count < 3 && available;
    }, [tours]);

    if (!hasTimelineTab || !showTour) return null;
    return <Tour steps={stepsTourTimeline} delay={1000} onClose={onCloseTourTimeline} />;
});

export default connect(mapStateToProps)(TimelineTour);
